import Icon from '../components/Icon.vue'

Icon.register({
  'star-of-life': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M472 334.4L336.1 256 472 177.6C479.6 173.1 482.3 163.4 477.9 155.7L445.8 100.3C441.4 92.6 431.6 90 424 94.4L288 172.8V16C288 7.2 280.9 0 272 0H208C199.1 0 192 7.2 192 16V172.9L56 94.4C48.4 90 38.6 92.6 34.2 100.3L2.1 155.7C-2.3 163.4 0.3 173.1 8 177.6L143.9 256 8 334.4C0.3 338.9-2.3 348.6 2.1 356.3L34.2 411.7C38.6 419.4 48.4 422 56 417.6L192 339.1V496C192 504.8 199.1 512 208 512H272C280.9 512 288 504.8 288 496V339.1L424 417.6C431.6 422 441.4 419.4 445.8 411.7L477.9 356.3C482.3 348.6 479.6 338.9 472 334.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-of-life.js
// module id = 5Mae
// module chunks = 144